/* tslint:disable */

/**
 */
export class UserUpdate {
    fullname?: string;
    id?: number;
    company_id?: number;
    rfid?: string;
    username?: string;
    email?: string;
    role_id?: number;
    birthday?: string;
    address?: string;
    sidn?: string;
    gender?: number;
    phone?: string;
}
